<template>
    <div>
        <RequestInformation
            :request="request"
        />

        <b-card no-body>
            <div class="card-header">
                <div class="col-md-6 pl-0">
                    <b-card-title>
                        {{ $t('Component(ReceivedRequestViewRequest):product-information') }}
                    </b-card-title>
                </div>
            </div>
            <table class="table">
                <thead>
                    <th>{{ $t('Component(ReceivedRequestViewRequest):product-information-customer') }}</th>
                    <th>{{ $t('Component(ReceivedRequestViewRequest):product-information-product') }}</th>
                    <th>{{ $t('Component(ReceivedRequestViewRequest):product-information-product-id') }}</th>
                    <th>{{ $t('Component(ReceivedRequestViewRequest):product-information-request-deadline') }}</th>
                </thead>
                <tbody>
                    <tr>
                        <td>{{ request.customer ? request.customer.title : '' }}</td>
                        <td>{{ request.product.id ? request.product.names[0].value : '' }}</td>
                        <td>{{ request.product && request.product.identifiers.length > 0 ? request.product.identifiers[0].value : '' }}</td>
                        <td>{{ request.validTo|moment('Y-MM-DD') }}</td>
                    </tr>
                </tbody>
            </table>
        </b-card>

        <b-row>
            <b-col md="6" lg="6">
                <InformationRequested :request="request" />
            </b-col>
            <b-col md="6" lg="6">
                <Conversation
                    :request-id="request.id"
                    :height="250"
                />
            </b-col>
        </b-row>
    </div>
</template>
<script>
import {Conversation} from "@core/components/messenger";
import RequestInformation from "@/views/request/received/components/RequestInformation";
import InformationRequested from "@/views/request/components/InformationRequested";
import { BRow, BCol, BCard, BCardTitle, BListGroup, BListGroupItem } from 'bootstrap-vue'

export default {
    components: {
        BRow, BCol,
        BCard,
        BCardTitle,
        BListGroup, BListGroupItem,
        Conversation, RequestInformation,
        InformationRequested,
    },
    props: {
        request: {
            type: Object,
            default() {
                return {
                    id: null,
                    product: {
                        identifiers: []
                    }
                };
            }
        },
    },
}
</script>
